import { useFollowingCoachFromBlogCard } from "../../../../hooks/blogs";
import { useBlogCardFollowContext } from "./BlogCardFollowProvider";
import { DefaultLoadingComponent } from "../../../global/defaultLoading/DefaultLoadingComponent";
import { PersonAddOutlined } from "@mui/icons-material";
import { AppTextButton } from "../../../global/ui/buttons";
import { followCoach, unfollowCoach } from "../../../../api/coaches";
import useUser from "../../../../hooks/user/useUser";
import { RootState } from "../../../../redux/store";
import { useSelector } from "react-redux";

export const BlogCardModalFollow = () => {
  const { state } = useBlogCardFollowContext();

  useFollowingCoachFromBlogCard({ coachId: state.coach.id });

  if (state.isFollowing == null) {
    return <DefaultLoadingComponent height={40} />;
  }

  if (state.isFollowing) {
    return <BlogCardUnfollow />;
  }

  return <BlogCardFollow />;
};

const BlogCardFollow = () => {
  const { state, dispatch } = useBlogCardFollowContext();
  const { user } = useUser();
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  const followHandler = async () => {
    dispatch({ isFollowing: true });

    await followCoach(state.coach.id, user.token);
  };

  return (
    <AppTextButton
      sx={{
        color: colors.surface.onSurface,
        fontSize: "0.875rem",
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        void followHandler();
      }}
    >
      <PersonAddOutlined
        sx={{
          color: colors.surface.onSurfaceVariant,
          paddingRight: "1rem",
        }}
      />
      Follow Creator
    </AppTextButton>
  );
};

const BlogCardUnfollow = () => {
  const { state, dispatch } = useBlogCardFollowContext();
  const { user } = useUser();
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  const unfollowHandler = async () => {
    dispatch({ isFollowing: false });

    await unfollowCoach(state.coach.id, user.token);
  };

  return (
    <AppTextButton
      sx={{
        color: colors.surface.onSurface,
        fontSize: "0.875rem",
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        void unfollowHandler();
      }}
    >
      <PersonAddOutlined
        sx={{
          color: colors.surface.onSurfaceVariant,
          paddingRight: "1rem",
        }}
      />{" "}
      Unfollow Creator
    </AppTextButton>
  );
};
